import { z } from 'zod';
import { BaseFacilityDTOSchema } from "./facilities.dto.js";
export const FindAllFacilitiesInputDTOSchema = z.object({
    page: z.number().int().positive().default(1),
    limit: z.number().int().positive().max(100).default(20),
    companyId: z.string().uuid().optional(),
});
export const FindAllFacilitiesOutputDTOSchema = z.object({
    facilities: z.array(BaseFacilityDTOSchema),
    total: z.number(),
    page: z.number(),
    limit: z.number(),
});
//# sourceMappingURL=find-all-facilities.dto.js.map